import React from 'react';
import LegalDocumentPage from '@/components/LegalDocumentPage';

/**
 * SMS Terms — publicly accessible at /sms-terms.
 *
 * This page exists to satisfy 10DLC (Twilio / The Campaign Registry)
 * opt-in review: carrier reviewers click this URL and verify the
 * SMS-program disclosure mirrors the consent text shown at the actual
 * opt-in checkbox during parent registration. The body markdown lives
 * in backend/legal_documents.py (SMS_TERMS_MD) and is fetched via
 * GET /api/public/legal/sms so the carrier-audited copy never drifts.
 */
export default function SmsTerms() {
    return <LegalDocumentPage docType="sms" />;
}
